// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6cbe120d","453":"c23786e6","732":"6122b065","977":"e1f3cebd"}[chunkId] + ".chunk.js";
};